<template>
  <div>
    <el-table :data="list" border style="width: 80%; margin-left: 50px">
      <el-table-column prop="account" label="账号"> </el-table-column>
      <el-table-column prop="regtime" label="注册时间"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getSubaccount();
  },
  methods: {
    async getSubaccount() {
      let uid = sessionStorage.getItem("uid");
      const res = await axios.post(
        "https://xlogin.us/api/my_share_list.php",
        qs.stringify({
          uid: uid,
        })
      );
      if (res.data.code === 200) {
        this.list = res.data.data;
      }else{
        this.$message.error(res.data.msg)
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 25%;
}
/deep/ .el-button {
  margin: 10px;
}
/deep/ .el-table td {
  text-align: center;
}
/deep/ .el-table th {
  background-color: #f5f7fa;
  text-align: center;
}
</style>